import { products } from "@/pages/ai/js/ai-feature";

export default {
  namespaced: true,
  state: {
    // 产品列表
    products: JSON.parse(JSON.stringify(products)),
    aiKeywords: "",
    // 背景列表
    aiBackgrounds: [],
    // 元素列表
    aiElements: [],
    // 海报内容区背景框
    contentStyles: [],
    // 业务线logos
    logoOptions: [],
    // 成套的素材
    materialSuites: [],
    // 当前选中的素材套件
    currentMaterialSuite: {},
    // 所有cover尺寸
    allCoverSizes: [],
    // 所有banner尺寸
    allBannerSizes: [],
    // 缩略图的文案
    thumbPaperwork: ["", ""],
    // ai绘图历史记录
    aiDrawHistories: [],
  },
  mutations: {
    updateAiKeywords (state, keywords) {
      state.aiKeywords = keywords;
    },
    setAiElements (state, { backgrounds, elements, contentStyles }) {
      state.aiBackgrounds = backgrounds;
      state.aiElements = elements;
      state.contentStyles = contentStyles;
    },
    setLogos (state, logoOptions) {
      state.logoOptions = logoOptions;
    },
    setMaterialSuites (state, materialSuites) {
      state.materialSuites = materialSuites;
      state.currentMaterialSuite = state.materialSuites[0];
    },
    setCurrentMaterialSuite (state, materialSuite) {
      state.currentMaterialSuite = materialSuite;
    },
    // 设置是否显示产品
    setProduct (state, product) {
      product.isShow = !product.isShow;
    },
    setAllSizes (
      state,
      { allBannerSizes, allCoverSizes, allBannerPaperworks, allCoverPaperworks }
    ) {
      assembleSizeAndPaperworks(allCoverSizes, allCoverPaperworks);
      assembleSizeAndPaperworks(allBannerSizes, allBannerPaperworks);
      state.allCoverSizes = allCoverSizes;
      state.allBannerSizes = allBannerSizes;
      const paperwork = allCoverPaperworks
        ? allCoverPaperworks.find((paperwork) => paperwork.id === 0)
        : {};
      if (paperwork && paperwork.texts) {
        state.thumbPaperwork = paperwork.texts.map((text) => text.text);
      }
    },
    updateAiDrawHistories (state, aiDrawHistories) {
      if (Array.isArray(aiDrawHistories)) {
        state.aiDrawHistories = aiDrawHistories;
      } else if (typeof aiDrawHistories === "object") {
        state.aiDrawHistories.push(aiDrawHistories);
      }
    },
    clearAiCacheInfo (state) {
      state.aiKeywords = "";
      state.aiDrawHistories = [];
      state.aiBackgrounds = [];
      state.aiElements = [];
      state.materialSuites = [];
      state.currentMaterialSuite = {};
      state.allCoverSizes = [];
      state.allBannerSizes = [];
      state.thumbPaperwork = ["", ""];
      state.contentStyles = [];
      state.logoOptions = [];
    },
  },
};
// 组装尺寸和文案
function assembleSizeAndPaperworks (groupSizes, allPaperworks) {
  groupSizes.forEach((group) => {
    group.sizes.forEach((size) => {
      // 找到尺寸对应的文案
      const paperworks = allPaperworks
        ? allPaperworks.find((paperwork) => paperwork.id === size.id) || { texts: [] }
        : { texts: [] };
      // 把文案组装到尺寸中
      size.textStyle.forEach((textStyle, index) => {
        textStyle.text = paperworks.texts[index]?.text || "";
      });
    });
  });
}
